import React from 'react'

function BusinessCaseThree() {
    return (
        <div>
            {/* business goal area */}
            <div className="rts-business-goal rts-business-goal5 mt--0 rts-section-gapBottom">
                <div className="container">

                    {/* TITLE */}
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="title-area">
                                <span className="sub">Nossos Diferenciais</span>
                                <h2 className="title">
                                    Por que o GB Grupo é referência <br /> no mercado financeiro?
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center align-items-center">

                        {/* LEFT COLUMN */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 first-child">
                            <ul className="content-box first">

                                <li className="content left">
                                    <h5 className="main-title">Atuação Integrada</h5>
                                    <p className="desc">
                                        Conectamos crédito, inteligência de mercado, consultoria e seguros em um único ecossistema.
                                    </p>
                                </li>

                                <li className="content left one">
                                    <h5 className="main-title">Capilaridade Nacional</h5>
                                    <p className="desc">
                                        Atuação em todo o Brasil, atendendo empresas, produtores rurais e pessoas físicas.
                                    </p>
                                </li>

                                <li className="content left">
                                    <h5 className="main-title">Mais de 35 Anos de Experiência</h5>
                                    <p className="desc">
                                        Especialistas com trajetória sólida no sistema financeiro e bancário.
                                    </p>
                                </li>

                            </ul>
                        </div>

                        {/* CENTER IMAGE */}
                        <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 text-center">
                            <div className="business-goal-one">
                                <img
                                    src="assets/images/home/7.png"
                                    alt="Business_Goal"
                                />
                                <div className="shape">
                                    <img src="assets/images/business-goal/icon/line.png" alt="" />
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <ul className="content-box last">

                                <li className="content right">
                                    <h5 className="main-title">Visão Consultiva</h5>
                                    <p className="desc">
                                        Soluções personalizadas conforme o perfil, momento e necessidade de cada cliente.
                                    </p>
                                </li>

                                <li className="content right two">
                                    <h5 className="main-title">Parcerias Estratégicas</h5>
                                    <p className="desc">
                                        Acesso a bancos, cooperativas, fintechs e ao mercado de capitais.
                                    </p>
                                </li>

                                <li className="content right">
                                    <h5 className="main-title">Agilidade e Segurança</h5>
                                    <p className="desc">
                                        Processos transparentes, atendimento ágil e alto nível técnico em todas as operações.
                                    </p>
                                </li>

                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            {/* business goal area End */}
        </div>
    )
}

export default BusinessCaseThree
